export default {
	sidebarState: 9
};
